import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useSiteData, defaultSettings, telHref } from "@/api";

const Footer = () => {
  const site = useSiteData({ chantiers: null, services: null, settings: defaultSettings });
  const s = site.settings || defaultSettings;

  return (
    <footer className="bg-ink text-cream" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 md:grid-cols-3 lg:px-12">
        <div>
          <p className="flex items-center gap-3 font-serif text-3xl tracking-tight">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white p-1.5">
              <img src="/chantiers/logo-mark.png" alt="Logo Alexis Peinture" className="h-full w-auto" />
            </span>
            <span>
              Alexis <span className="italic text-sand">Peinture</span>
            </span>
          </p>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-cream/70">
            Artisan peintre en bâtiment, spécialiste de la peinture intérieure
            décorative. Un travail rigoureux et soigné, du premier coup de
            pinceau à la dernière finition.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-sand">Navigation</p>
          <nav className="mt-5 flex flex-col gap-3 text-sm text-cream/80">
            <Link to="/" data-testid="footer-link-accueil" className="transition-colors duration-300 hover:text-sand">Accueil</Link>
            <Link to="/services" data-testid="footer-link-services" className="transition-colors duration-300 hover:text-sand">Services</Link>
            <Link to="/realisations" data-testid="footer-link-realisations" className="transition-colors duration-300 hover:text-sand">Réalisations</Link>
            <Link to="/a-propos" data-testid="footer-link-a-propos" className="transition-colors duration-300 hover:text-sand">À propos</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="transition-colors duration-300 hover:text-sand">Contact &amp; devis</Link>
          </nav>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-sand">Contact</p>
          <div className="mt-5 flex flex-col gap-3 text-sm text-cream/80">
            <a href={telHref(s.telephone)} data-testid="footer-phone" className="flex items-center gap-3 transition-colors duration-300 hover:text-sand">
              <Phone size={15} className="text-sand" /> {s.telephone}
            </a>
            <a href={`mailto:${s.email}`} data-testid="footer-email" className="flex items-center gap-3 transition-colors duration-300 hover:text-sand">
              <Mail size={15} className="text-sand" /> {s.email}
            </a>
            <p className="flex items-start gap-3">
              <MapPin size={15} className="mt-0.5 shrink-0 text-sand" />
              {s.zone}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-cream/10 px-6 py-6 text-center text-xs text-cream/50">
        <p>© 2026 Alexis Peinture — Alexis Delcey, artisan peintre en bâtiment. Tous droits réservés.</p>
        <p className="mt-3 flex items-center justify-center gap-6">
          <Link to="/mentions-legales" data-testid="footer-link-mentions" className="transition-colors duration-300 hover:text-sand">
            Mentions légales
          </Link>
          <Link to="/confidentialite" data-testid="footer-link-confidentialite" className="transition-colors duration-300 hover:text-sand">
            Politique de confidentialité
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
